import { gql } from "@apollo/client";
import type { IMagazineEdition } from "types/Magazine.type";

export interface ICreateMagazineEditionInput {
  title: string;
  canvasEmbed?: string;
  previewImage?: string;
}

export interface IUpdateMagazineEditionInput
  extends Partial<ICreateMagazineEditionInput> {
  id: string;
}

export interface IMagazineEditionMutationResponse {
  createMagazineEdition?: IMagazineEdition;
  updateMagazineEdition?: IMagazineEdition;
  deleteMagazineEdition?: IMagazineEdition;
}

const MAGAZINE_EDITION_MUTATION_FIELDS = gql`
  fragment MagazineEditionMutationFields on MagazineEdition {
    id
    title
    canvasEmbed
    previewImage
    createdAt
    updatedAt
    createdById
    canManage
    createdBy {
      id
      name
      lastname
      profileImage
      email
    }
  }
`;

const CREATE_MAGAZINE_EDITION = gql`
  ${MAGAZINE_EDITION_MUTATION_FIELDS}
  mutation CreateMagazineEdition(
    $createMagazineEditionInput: CreateMagazineEditionInput!
  ) {
    createMagazineEdition(
      createMagazineEditionInput: $createMagazineEditionInput
    ) {
      ...MagazineEditionMutationFields
    }
  }
`;

const UPDATE_MAGAZINE_EDITION = gql`
  ${MAGAZINE_EDITION_MUTATION_FIELDS}
  mutation UpdateMagazineEdition(
    $updateMagazineEditionInput: UpdateMagazineEditionInput!
  ) {
    updateMagazineEdition(
      updateMagazineEditionInput: $updateMagazineEditionInput
    ) {
      ...MagazineEditionMutationFields
    }
  }
`;

const DELETE_MAGAZINE_EDITION = gql`
  mutation DeleteMagazineEdition($id: String!) {
    deleteMagazineEdition(id: $id) {
      id
    }
  }
`;

export default {
  CREATE_MAGAZINE_EDITION,
  UPDATE_MAGAZINE_EDITION,
  DELETE_MAGAZINE_EDITION,
};
